import Vue from 'vue';

//Componentes globales

import Chart from '@/components/ui/Chart';
import FilterDropdown from '@/components/ui/FilterDropdown';
import FilterDropdownVisits from '@/components/ui/FilterDropdownVisits';
import PercentagesSummary from '@/components/ui/PercentagesSummary';
import PercentagesDetail from '@/components/ui/PercentagesDetail';
import ProgressChart from '@/components/ui/ProgressChart';
import SideBar from '@/components/ui/SideBar';
import SideBarItem from '@/components/ui/SideBarItem';
import Spinner from '@/components/ui/Spinner';
import SchoolSelecter from '@/components/ui/SchoolSelecter';
import TopBar from '@/components/ui/TopBar';
import TitleBar from '@/components/ui/TitleBar';
import NoData from '@/components/ui/NoData';
import StatusBadge from '@/components/ui/StatusBadge';

Vue.config.productionTip = false;

Vue.component('chart', Chart);
Vue.component('filter-dropdown', FilterDropdown);
Vue.component('filter-dropdown-visits', FilterDropdownVisits);
Vue.component('percentages-summary', PercentagesSummary);
Vue.component('percentages-detail', PercentagesDetail);
Vue.component('progress-chart', ProgressChart);
Vue.component('side-bar', SideBar);
Vue.component('side-bar-item', SideBarItem);
Vue.component('school-selecter', SchoolSelecter);
Vue.component('spinner', Spinner);
Vue.component('top-bar', TopBar);
Vue.component('title-bar', TitleBar);
Vue.component('no-data', NoData);
Vue.component('status-badge', StatusBadge);



// WEBPACK FOOTER //
// ./src/config/vue.js